export default function vibrate (times, len = false) {
  const length = typeof len === 'number' ? len : 40
  const space = 30

  if (window.navigator.vibrate) {
    const pattern = new Array(times * 2 - 1).fill(false)
      .map((_, i) => i % 2 ? space : length)

    const vibrated = window.navigator.vibrate(pattern)
    return vibrate
  }
}
